import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import {
  DestinationDetails,
  DestinationPlatform,
  DestinationPlatformData,
  isYouTubeCatalogPlatform,
  YouTubeVideoCategoryCatalog,
} from '../../../domain/destinations';

export type DestinationSettingsPanelState = 'idle' | 'loading' | 'ready' | 'error';
export type DestinationSettingsAppearance = 'default' | 'clipping-sidebar';

@Component({
  selector: 'evrideo-destination-settings-panel',
  templateUrl: './destination-settings-panel.component.html',
  styleUrls: ['./destination-settings-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DestinationSettingsPanelComponent {
  @Input({ required: true }) platform!: DestinationPlatform;
  @Input({ required: true }) state: DestinationSettingsPanelState = 'idle';
  @Input() details: DestinationDetails | null = null;
  @Input() videoCategories: YouTubeVideoCategoryCatalog | null = null;
  @Input() errorMessage: string | null = null;
  @Input() platformData: DestinationPlatformData | null = null;
  @Input() readonly = true;
  @Input() canSave = false;
  @Input() isSaving = false;
  @Input() appearance: DestinationSettingsAppearance = 'default';

  @Output() platformDataChange = new EventEmitter<DestinationPlatformData>();
  @Output() save = new EventEmitter<void>();

  get isYouTube(): boolean {
    return isYouTubeCatalogPlatform(this.platform);
  }

  get isReady(): boolean {
    return this.state === 'ready' && this.details != null;
  }

  onPlatformDataChange(data: DestinationPlatformData): void {
    this.platformDataChange.emit(data);
  }

  onSaveClick(): void {
    if (!this.canSave || this.isSaving || this.readonly) {
      return;
    }
    this.save.emit();
  }
}
